export default __webpack_public_path__ + "static/media/photoprofil2.0abd5d38.png";